// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"126":"resetpwd","293":"use_proxy","346":"uc_ipm","535":"login","830":"signup","996":"info"}[chunkId] + "." + __webpack_require__.h() + ".js";
};